const getRandomCharFromString = (array: string): string => {
  return array[Math.floor(Math.random() * array.length)]
}

const shuffleString = (value: string): string => {
  const array = value.split("")

  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }

  return array.join("")
}

export const generatePassword = (length: number = 8): string => {
  let password: string = ""

  const chars = "abcdefghijklmnopqrstuvwxyz"
  const numbers = "123456789"
  const capitalChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  const specialChars = "!@#$%^&*()"

  // Pick a Number
  password += getRandomCharFromString(numbers)
  // Pick a Capital Letter
  password += getRandomCharFromString(capitalChars)
  // Pick a Special Character
  password += getRandomCharFromString(specialChars)

  // Fill with (length - 3) more digits
  for (let i = 0; i < length - 3; i++) {
    password += getRandomCharFromString(chars)
  }

  // Shuffle the password
  password = shuffleString(password)

  return password
}
